import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, Typography } from "@mui/material";
import { getInvoice, getInvoiceDownload } from "redux/actions/UserTrip";
import InvoiceMap from "./InvoiceMap";
import Loader from "components/loader/Loader";
import ArrowLineDown from "assets/images/ArrowLineDown.svg";

function InvoiceDetails() {
  const {id, magicToken} = useParams()
  const dispatch = useDispatch();
  const {state} = useLocation();
  const tripDetails = useSelector((state) => state?.userInvoice?.userInvoice?.data);
  const loader = useSelector((state) => state?.userInvoice?.loading);
  const downloadLoader = useSelector((state) => state?.userInvoiceDownload?.loading);
  const invoiceId = state?.id;
  const tripId = state?.tripId;
  const filterData = {
    id: id ? id : invoiceId,
    status: '',
    page: '',
    pageSize: '',
    date: '',
    type: '',
    magicToken:magicToken || ''
  };

  useEffect(() => {
    dispatch(getInvoice(filterData));
  }, []);

  const onDownload = () => {
    const downloadData = {
      id:invoiceId || tripDetails?.id
    }
    dispatch(getInvoiceDownload(downloadData))
  }

  return (
    <Grid>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item md={10} className="margin10">
          {loader ? '' : <Typography className="font28 fontMedium">
            Trip {" "+(tripId ? tripId : tripDetails?.tripId)}  <span className="completeText">{tripDetails?.status || ''}</span>
          </Typography>}
        </Grid>
        {!magicToken &&<Grid item md={1.5}>
          <Button className="btnSubvendor" onClick={() => onDownload()} disabled={downloadLoader}>
            {downloadLoader ? 'Loading...' : 'Download'}
            <img src={ArrowLineDown} alt="ArrowLineDown" />
          </Button>
        </Grid>}
      </Grid>
      {loader? 
        <Loader/> 
        :
      <Grid className="invoiceMap">
        <InvoiceMap tripDetails={tripDetails} magicToken={magicToken} />
      </Grid>}
    </Grid>
  );
}

export default InvoiceDetails;
